'use client';

import { useTranslations } from 'next-intl';
import { useModalContext } from '@/shared/components/overlay/use-modal-context';
import { useEffect, useState } from 'react';
import { MessageBox } from '@/shared/components';
import {
  WishlistForm,
  WishlistSuccessResponse,
} from '@/features/games/internal/components/wishlists/new-edit/wishlist-form';
import { useOverlayStore } from '@/shared/components/overlay/overlay.store';

type CreateWishlistOverlayProps = {
  onSuccess?: (response: WishlistSuccessResponse) => void;
};

export const CreateWishlistOverlay = ({ onSuccess }: CreateWishlistOverlayProps) => {
  const [error, setError] = useState<string | null>(null);
  const { hideOverlay } = useOverlayStore();
  const t = useTranslations('Account.wishlists.create');

  const handleSuccess = (response: WishlistSuccessResponse) => {
    onSuccess?.(response);
    hideOverlay();
  };

  const handleCancel = () => {
    hideOverlay();
  };

  const errorMessageTitle = t('errors.messageBoxTitle');

  const { setHeader } = useModalContext();

  useEffect(() => {
    setHeader(<h1 className='font-heading flex-1 px-4 text-center text-xl'>{t('title')}</h1>);
  }, [setHeader, t]);

  return (
    <div className='py-6'>
      <div className='flex w-full flex-col items-center px-4'>
        {error && (
          <div role='alert' className='w-full'>
            <MessageBox type='error' className='mb-4 w-full' title={errorMessageTitle}>
              {error}
            </MessageBox>
          </div>
        )}

        <div className='flex w-full max-w-3xl flex-col gap-6'>
          <WishlistForm
            setRootError={setError}
            onSuccess={handleSuccess}
            onCancel={handleCancel}
            buttonAlignment='right'
          />
        </div>
      </div>
    </div>
  );
};
